
import { useAuth } from "@/contexts/auth"; // Updated import
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface RedirectionOptionsProps {
  autoRedirect: boolean;
  setAutoRedirect: (autoRedirect: boolean) => void;
}

export const RedirectionOptions = ({ autoRedirect, setAutoRedirect }: RedirectionOptionsProps) => {
  return (
    <div className="mt-4 flex items-center justify-center">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="auto-redirect"
          checked={autoRedirect}
          onCheckedChange={() => setAutoRedirect(!autoRedirect)}
        />
        <Label htmlFor="auto-redirect" className="text-sm text-gray-600 cursor-pointer">
          Redirection automatique après connexion
        </Label>
      </div>
    </div>
  );
};
